module.exports = __webpack_public_path__ + "img/collection-memoireRingsWhite.f09b729.webp";